// import Home from '@/views/home/Home.vue'
import Vue from "vue";
import VueToast from "vue-toast-notification";
Vue.use(VueToast, {
    position: "top-right",
    duration: 5000,
});
import BasicLayout from "@/layouts/BasicLayout.vue";
import Login from "@/views/login/Login.vue";
import auth from "@/mixin/cognito.mixin";
import Loading from "@/views/Loading/Loading.vue"
const routes = [{
        path: "/version",
        component: BasicLayout,
        meta: {
            title: "バージョン情報",
            icon: "fas fa-code-branch",
            requiresAuth: true,
        },
        hideChildrenInMenu: true,
        children: [{
            path: "/",
            name: "Version",
            component: () =>
                import ("@/views/version/Version.vue"),
            meta: {
                title: "バージョン情報",
            },
        }, ],
    },
    {
        path: "/",
        name: "Login",
        component: Login,
    },
    {
        path: "/login",
        beforeEnter() {
            auth.data().auth.getSession();
        },
        hidden: true,
    },
    {
        path: "/login/oauth2/code/cognito",
        component: Loading,
        hidden: true,
    },
    {
        path: "/story-mode",
        name: "Story mode",
        component: BasicLayout,
        hidden: true,
        meta: {
            title: "LIST_LESSON",
            icon: "fas fa-sitemap",
            requiresAuth: true,
        },
        hideChildrenInMenu: true,
        children: [
            // // List season
            // {
            //   path: "/story-mode/list-season",
            //   name: "List Season",
            //   component: () => import("@/views/listSeason/ListSeason.vue"),
            //   meta: {
            //     // title: "LIST_LESSON",
            //   },
            // },
            // // List chapter
            // {
            //   path: "/story-mode/:season/list-chapter",
            //   name: "List Chapter",
            //   component: () => import("@/views/listChapter/ListChapter.vue"),
            //   meta: {
            //     title: "LIST_CHAPTER",
            //   },
            // },
            // List question of season
            {
                path: "/story-mode/:season/list-general-of-season",
                name: "List General OF Season",
                component: () =>
                    import ("@/views/listGeneral/ListGeneral.vue"),
            },
            // Sort List question of season
            {
                path: "/story-mode/:season/list-general-of-season/sort-list-general-of-season",
                name: "Sort List General OF Season",
                component: () =>
                    import ("@/views/listGeneral/SortList.vue"),
            },
            // Select create List question of season
            {
                path: "/story-mode/:season/list-general-of-season/select-list-general-of-season",
                name: "Select Create General OF Season",
                component: () =>
                    import ("@/views/listGeneral/SelectCreateGeneral.vue"),
            },
            // Creat question of season
            {
                path: "/story-mode/:season/create-general-of-season",
                name: "Create General OF Season",
                component: () =>
                    import ("@/views/listGeneral/AddItemGeneral.vue"),
                meta: {
                    title: "CREATE_SEASON_SUMMARY",
                },
            },
            // Update question of season
            {
                path: "/story-mode/:season/update-general-of-season/:id",
                name: "Update General OF Season",
                component: () =>
                    import ("@/views/listGeneral/UpdateItemGeneral.vue"),
                meta: {
                    title: "UPDATE_SEASON_SUMMARY",
                },
            },
            // Detail question of season
            {
                path: "/story-mode/:season/detail-general-of-season/:id",
                name: "Detail General OF Season",
                component: () =>
                    import ("@/views/listGeneral/ViewDetailGeneral.vue"),
                meta: {
                    title: "SEASON_SUMMARY_DETAIL",
                },
            },
            // List question of chapter
            {
                path: "/story-mode/:chapter/list-general-of-chapter",
                name: "List General OF Chapter",
                component: () =>
                    import ("@/views/listGeneral/ListGeneral.vue"),
            },
            // Sort List question of Chapter
            {
                path: "/story-mode/:chapter/sort-list-general-of-chapter",
                name: "Sort List General OF Chapter",
                component: () =>
                    import ("@/views/listGeneral/SortList.vue"),

            },
            // Select create List question of Chapter
            {
                path: "/story-mode/:chapter/select-list-general-of-chapter",
                name: "Select Create General OF Chapter",
                component: () =>
                    import ("@/views/listGeneral/SelectCreateGeneral.vue"),
            },
            // Creat question of chapter
            {
                path: "/story-mode/:chapter/create-general-of-chapter",
                name: "Create General OF Chapter",
                component: () =>
                    import ("@/views/listGeneral/AddItemGeneral.vue"),
                meta: {
                    title: "CREATE_CHAPTER_SUMMARY",
                },
            },
            // Update question of chapter
            {
                path: "/story-mode/:chapter/update-general-of-chapter/:id",
                name: "Update General OF Chapter",
                component: () =>
                    import ("@/views/listGeneral/UpdateItemGeneral.vue"),
                meta: {
                    title: "UPDATE_CHAPTER_SUMMARY",
                },
            },
            // Detail question of chapter
            {
                path: "/story-mode/:chapter/detail-general-of-chapter/:id",
                name: "Detail General OF Chapter",
                component: () =>
                    import ("@/views/listGeneral/ViewDetailGeneral.vue"),
                meta: {
                    title: "CHAPTER_SUMMARY_DETAIL",
                },
            },
            // Sort List question of Section
            {
                path: "/story-mode/:section/sort-list-general-of-section",
                name: "Sort List General OF Section",
                component: () =>
                    import ("@/views/listGeneral/SortList.vue"),
            },
            // List question of section
            {
                path: "/story-mode/:section/list-general-of-section",
                name: "List General OF Section",
                component: () =>
                    import ("@/views/listGeneral/ListGeneral.vue"),
                meta: {
                    title: "練習問題",
                },
            },
            // Creat question of section
            {
                path: "/story-mode/:section/create-general-of-section",
                name: "Create General OF Section",
                component: () =>
                    import ("@/views/listGeneral/AddItemGeneral.vue"),
                meta: {
                    title: "CREATE_SECTION_SUMMARY",
                },
            },
            // Update question of section
            {
                path: "/story-mode/:section/update-general-of-section/:id",
                name: "Update General OF Section",
                component: () =>
                    import ("@/views/listGeneral/UpdateItemGeneral.vue"),
                meta: {
                    title: "UPDATE_SECTION_SUMAMRY",
                },
            },
            // Detail question of section
            {
                path: "/story-mode/:section/detail-general-of-section/:id",
                name: "Detail General OF Section",
                component: () =>
                    import ("@/views/listGeneral/ViewDetailGeneral.vue"),
                meta: {
                    title: "SECTION_SUMMARY_DETAIL",
                },
            },
            {
                path: "/story-mode/:season/:chapter/detail-section/:section",
                name: "Detail Section",
                component: () =>
                    import ("@/views/listSection/SectionDetail.vue"),
                meta: {
                    title: "DETAIL_SECTION",
                },
            },
            {
                path: "/story-mode/grammar/:section/add-grammar/",
                name: "Add Grammar OF Section",
                component: () =>
                    import ("@/views/listSection/Grammar/AddGrammar.vue"),
                meta: {
                    title: "文法解説登録",
                },
            },
            {
                path: "/story-mode/grammar/:section/update-Grammar/:grammar",
                name: "Update Grammar OF Section",
                hidden: true,
                component: () =>
                    import ("@/views/listSection/Grammar/UpdateGrammar.vue"),
                meta: {
                    title: "文法解説",
                },
            },
            {
                path: "/story-mode/:section/detail-skit/:skit",
                name: "Detail Skit",
                component: () =>
                    import ("@/views/listSection/Skit/DetailSkit.vue"),
                meta: {
                    title: "スキット",
                },
            },
            {
                path: "/story-mode/:chapter/detail-section/:section/add-expression/",
                name: "Add Expression OF Section",
                component: () =>
                    import ("@/views/listSection/Expression/AddExpression.vue"),
                meta: {
                    title: "表現・文型登録",
                },
            },
            {
                path: "/story-mode/detail-section/:section/update-expression/:expression",
                name: "Update Expression OF Section",
                component: () =>
                    import ("@/views/listSection/Expression/UpdateExpression.vue"),
                meta: {
                    title: "表現・文型編集",
                },
            },
        ],
    },
    {
        path: "/self-study",
        name: "Self Study",
        component: BasicLayout,
        meta: {
            title: "自習",
            icon: "fas fa-book",
            requiresAuth: true,
        },
        children: [{
                path: "/vocaburary-book/",
                name: "Vocabulary Book",
                component: () =>
                    import ("@/views/vocabularyBook/VocabularyBook.vue"),
                meta: {
                    title: "単語帳",
                },
            },
            {
                path: "/vocaburary-book/tab/:tabId",
                name: "Detail Tab",
                component: () =>
                    import ("@/views/vocabularyBook/tab/category/CategoryList.vue"),
                hidden: true,
                meta: {
                    title: "カテゴリ",
                },
            },
            {
                path: "/vocaburary-book/tab/:tabId/:categoryId",
                name: "Detail Category",
                component: () =>
                    import (
                        "@/views/vocabularyBook/tab/category/vocabulary/VocabularyList.vue"
                    ),
                hidden: true,
                meta: {
                    title: "単語一覧",
                },
            },
            {
                path: "/vocaburary-book/tab/:tabId/category/:categoryId",
                name: "Create Vocabulary In Detail Category",
                component: () =>
                    import (
                        "@/views/vocabularyBook/tab/category/vocabulary/VocabularyAdd.vue"
                    ),
                hidden: true,
                meta: {
                    title: "単語登録",
                },
            },
            {
                path: "/vocaburary-book/tab/:tabId/category/:categoryId/:vocabularyId",
                name: "Update Vocabulary In Detail Category",
                component: () =>
                    import (
                        "@/views/vocabularyBook/tab/category/vocabulary/VocabularyUpdate.vue"
                    ),
                hidden: true,
                meta: {
                    title: "単語編集",
                },
            },
            {
                path: "/grammar/",
                name: "Grammar Of Self Study",
                component: () =>
                    import ("@/views/grammar/GrammarList.vue"),
                meta: {
                    title: "文法解説一覧",
                },
            },
            {
                path: "/grammar/create-grammar",
                name: "Grammar Create Of Self Study",
                hidden: true,
                component: () =>
                    import ("@/views/grammar/AddGrammar.vue"),
                meta: {
                    title: "文法解説登録",
                },
            },
            {
                path: "/grammar/update-Grammar/:grammar",
                name: "Grammar Update Of Self Study",
                hidden: true,
                component: () =>
                    import ("@/views/grammar/UpdateGrammar.vue"),
                meta: {
                    title: "文法解説編集",
                },
            },
            {
                path: "/time/",
                name: "Time",
                component: () =>
                    import ("@/views/time/ListTime.vue"),
                meta: {
                    title: "時間",
                },
            },
            {
                path: "/date/",
                name: "Date",
                component: () =>
                    import ("@/views/date/ListDate.vue"),
                meta: {
                    title: "日付",
                },
            },
            {
                path: "/drill/",
                name: "Drill",
                component: () =>
                    import ("@/views/drill/ListDrill.vue"),
                meta: {
                    title: "ドリル",
                },
            },
            {
                path: "/drill/list-exercises/:drillId",
                name: "List Exercises Of Drill",
                hidden: true,
                component: () =>
                    import ("@/views/drill/Exercises/ListExercises.vue"),
                meta: {
                    title: "問題",
                },
            },
            {
                path: "/drill/create-exercises/:drillId",
                name: "Create Exercises Of Drill",
                hidden: true,
                component: () =>
                    import ("@/views/drill/Exercises/CreateExercises.vue"),
                meta: {
                    title: "問題登録",
                },
            },
            {
                path: "/drill/:drillId/update-exercises/:exerciesID",
                name: "Update Exercises Of Drill",
                hidden: true,
                component: () =>
                    import ("@/views/drill/Exercises/UpdateExercises.vue"),
                meta: {
                    title: "問題編集",
                },
            },
            // Detail question of section
            {
                path: "/story-mode/:drillId/detail-exercise/:exerciesID",
                name: "Detail Exercises Of Drill",
                hidden: true,
                component: () =>
                    import ("@/views/drill/Exercises/ViewDetailExercises.vue"),
                meta: {
                    title: "問題詳細",
                },
            },
        ],
    },

    {
        path: "*",
        name: "404",
        hidden: true,
        component: () =>
            import ("@/views/exception/err404"),
    },
];
export default routes;